import axios from 'axios';
import AppConfig from "../../AppConfig";
import moment from "moment";
import {NotificationManager} from "react-notifications";

let URL = AppConfig.HOST_API();

export default {

    checkWiek(typ, dataUrodzenia) {
        switch (typ) {
            case "SM":
                if (moment().diff(dataUrodzenia, 'years') < 26) {
                    return true;
                } else {
                    NotificationManager.error("", "Przekroczono próg wieku uprawniającego do zniżki. ", 5000)
                    return false;
                }
            case "KM":
                if (moment().diff(dataUrodzenia, 'years') < 24) {
                    return true;
                } else {
                    NotificationManager.error("", "Przekroczono próg wieku uprawniającego do zniżki. ", 5000)
                    return false;
                }
            case "DM":
                if (moment().diff(dataUrodzenia, 'years') < 35) {
                    return true;
                } else {
                    NotificationManager.error("", "Przekroczono próg wieku uprawniającego do zniżki. ", 5000)
                    return false;
                }
            default:
                return true
        }
    },

    postLogin(login, pass) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/dostep' + AppConfig.V_LOG(),
            data: {
                login: login,
                pass: pass
            }
        });
    },

    postRegister(login, pass) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/klienci/register' + AppConfig.V_LOG(),
            data: {
                email: login,
                pass: pass
            }
        });
    },

    putRegister(idKl, login, pass, imie, nazwisko, pesel, nrDok, nrDokWaznyDo, dataUrodzenia, miejscowosc, kodPoczt, ulica, numerDomu, numerMieszkania, telefon, zdjecie) {
        return axios({
            method: 'PUT',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/klienci/' + idKl + AppConfig.V_LOG(),
            data: {
                "idKl": null,
                "email": login,
                "nrDok": nrDok,
                "nrDokWaznyDo": nrDokWaznyDo,
                "dataUrodzenia": dataUrodzenia,
                "nrTel": telefon,
                "imie": imie,
                "nazwisko": nazwisko,
                "kodPoczt": kodPoczt,
                "miejscowosc": miejscowosc,
                "ulica": ulica,
                "nrDomu": numerDomu,
                "nrMieszk": numerMieszkania,
                "pesel": pesel,
                "pass": pass,
                "plikiRequest": zdjecie
            }
        });
    },

    deletePlik(id) {
        return axios({
            method: 'DELETE',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/auth/klienci/plik/' + id + AppConfig.V_LOG(),
            auth: {
                username: JSON.parse(sessionStorage.getItem('loggedIn')).login,
                password: JSON.parse(sessionStorage.getItem('loggedIn')).pass
            },
        });
    },

    getKlient(idKl, login, pass) {
        return axios({
            method: 'GET',
            headers: {'Authorization': 'Basic ' + btoa(login + ':' + pass), 'Content-Type': 'application/json'},
            url: URL + 'client/api/auth/klienci/' + idKl + AppConfig.V_LOG(),
        });
    },

    changePassword(idKl, oldPass, newPass) {
        return axios({
            method: 'POST',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/klienci/changePassword' + AppConfig.V_LOG(),
            data: {
                "idKl": idKl,
                "oldPassword": oldPass,
                "newPassword": newPass
            }
        });
    },

    aktywujKonto(token) {
        return axios({
            method: 'GET',
            headers: {'Authorization': 'Basic '},
            url: URL + 'client/api/klienci/aktywujKonto/' + token + AppConfig.V_LOG(),
        });
    },

    resetHasla(email) {
        return axios({
            method: 'GET',
            headers: {'Authorization': 'Basic '},
            url: URL + 'client/api/klienci/resetujHaslo?email=' + email + AppConfig.V_LOG_SECOND_PARAM(),
        });
    },

    ustawNoweHaslo(token, pass) {
        return axios({
            method: 'POST',
            headers: {'Authorization': 'Basic '},
            url: URL + 'client/api/klienci/ustawNoweHaslo' + AppConfig.V_LOG(),
            data: {
                "token": token,
                "newPassword": pass,
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/loginComponents/LoginService.js